import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StyleSheet, css } from 'aphrodite';
import { ChevronDown, ChevronUp } from 'react-feather';

const formatKey = (key) => {
  return key
    .split(/(?=[A-Z])/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const Summary = ({ formData, onBack, onSubmit }) => {
  return (
    <motion.div
      className={css(styles.container)}
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <h2 className={css(styles.title)}>Summary</h2>
      <div className={css(styles.summaryContent)}>
        <SummarySection
          title='Personal Information'
          data={formData.personalInfo}
        />
        <SummarySection
          title='Contact Information'
          data={formData.contactInfo}
        />
        <SummarySection
          title='Emergency Contact'
          data={formData.emergencyContact}
        />
        <SummarySection
          title='Medical Information'
          data={formData.medicalInfo}
        />
        <SummarySection title='Preferences' data={formData.preferences} />
        <SummarySection
          title='Insurance Information'
          data={formData.insuranceInfo}
        />
      </div>
      <div className={css(styles.buttonContainer)}>
        {/* <motion.button
					className={css(styles.submitButton)}
					onClick={onSubmit}
					whileHover={{ scale: 1.05 }}
					whileTap={{ scale: 0.95 }}
				>
					Confirm & Submit
				</motion.button> */}
        <motion.button
          className={css(styles.button, styles.backButton)}
          onClick={onBack}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Back
        </motion.button>
      </div>
    </motion.div>
  );
};

const SummarySection = ({ title, data }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className={css(styles.section)}>
      <button
        className={css(styles.sectionTitle)}
        onClick={() => setIsOpen(!isOpen)}
      >
        {title}
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className={css(styles.sectionContent)}
          >
            {Object.entries(data).map(([key, value]) => (
              <div key={key} className={css(styles.dataItem)}>
                <span className={css(styles.dataLabel)}>{formatKey(key)}:</span>
                <span className={css(styles.dataValue)}>{value}</span>
              </div>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: '2rem'
  },
  title: {
    fontSize: '1.5rem',
    marginBottom: '1rem',
    color: '#2783F7'
  },
  summaryContent: {
    backgroundColor: '#f8fafc',
    borderRadius: '8px',
    padding: '1rem'
  },
  section: {
    marginBottom: '1rem'
  },
  sectionTitle: {
    fontSize: '1.2rem',
    color: '#4a5568',
    backgroundColor: 'transparent',
    border: 'none',
    borderBottom: '1px solid #e2e8f0',
    paddingBottom: '0.25rem',
    marginBottom: '0.5rem',
    width: '100%',
    textAlign: 'left',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer'
  },
  sectionContent: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '0.5rem 1rem',
    overflow: 'hidden'
  },
  dataItem: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0.25rem 0'
  },
  dataLabel: {
    fontSize: '0.8rem',
    color: '#718096',
    marginBottom: '0.125rem'
  },
  dataValue: {
    fontSize: '0.9rem',
    color: '#2d3748'
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    marginTop: '1rem'
  },
  button: {
    border: 'none',
    padding: '0.5rem 1rem',
    fontSize: '1rem',
    borderRadius: '5px',
    cursor: 'pointer'
  },
  backButton: {
    backgroundColor: '#e2e8f0',
    color: '#4a5568'
  },
  submitButton: {
    backgroundColor: '#2783F7',
    color: 'white',
    border: 'none',
    padding: '0.75rem 1.5rem',
    fontSize: '1rem',
    fontWeight: '600',
    borderRadius: '8px',
    cursor: 'pointer',
    display: 'block',
    width: '100%',
    maxWidth: '200px',
    margin: '1.5rem auto',
    transition: 'all 0.2s ease-in-out',
    boxShadow: '0 4px 6px rgba(39, 131, 247, 0.2)',
    ':hover': {
      backgroundColor: '#1c6ed8',
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 8px rgba(39, 131, 247, 0.3)'
    }
  },
  '@media (max-width: 768px)': {
    submitButton: {
      maxWidth: '100%',
      padding: '0.75rem 1rem',
      margin: '1rem auto'
    }
  }
});

export default Summary;
